import React from "react"
import { SpinnerPoint, SpinnerWrapper } from "./styled"

export interface SpinnerProps {
    points?: number
    pointSize?: number
    size?: number
    color?: string
}

export const Spinner = ({
    points = 12,
    pointSize = 6,
    size = 64,
    color,
}: SpinnerProps) => {
    const pointRadius = pointSize / 2
    const spinnerRadius = size / 2
    const center = spinnerRadius - pointRadius

    const angleDiff = 360 / points
    const delayDiff = 0.1
    const animLength = delayDiff * points

    let angle = 0
    let delay = 0
    const pointArray = []

    for (let i = 0; i < points; i++) {
        const angleRadians = (angle * Math.PI) / 180
        const left = center + Math.cos(angleRadians) * spinnerRadius
        const top = center + Math.sin(angleRadians) * spinnerRadius

        pointArray.push(
            <SpinnerPoint
                key={i}
                size={pointSize}
                top={top}
                left={left}
                color={color}
                animLength={animLength}
                animDelay={delay}
            />,
        )

        angle += angleDiff
        delay += delayDiff
    }

    return (
        <SpinnerWrapper size={size}>
            { pointArray }
        </SpinnerWrapper>
    )
}
